import request from '@/utils/request';
import Resource from '@/api/resource';

class materialResource extends Resource {
  constructor() {
    super('material');
  }
  materialApi(method, data) {
    const parameter = {
      url: `/tool/lab/toutiao`,
      method,
    };
    if (method === 'get') {
      parameter.params = data;
    }
    if (method === 'post') {
      parameter.data = data;
    }
    return request(parameter);
  }

  // 获取图片素材
  getAllPic(data) {
    return request({
      url: '/material/jrtt/getImages',
      method: 'get',
      params: data,
    });
  }

  // 获取视频素材
  getAllVidio(data) {
    return request({
      url: '/material/jrtt/getVideos',
      method: 'get',
      params: data,
    });
  }

  getMaterial(data) {
    return this.materialApi('get', data);
  }

  // 上传图片
  uloadImage(data){
    return request({
      url: '/material/local/uploadImage',
      method: 'POST',
      data,
      headers: {
        'Content-Type':	'multipart/form-data; charset=UTF-8',
      },
    });
  }

  // 获取图片base64
  getPicBase64Api(data){
    return request({
      url: `/material/local/getImageBase64`,
      method: 'get',
      params: data,
    });
  }

  /** 获取视频智能封面 */
  getVideoCutPic(data) {
    return request({
      url: '/material/local/getVideoScreenshot',
      method: 'get',
      params: data,
    });
  }
}

export { materialResource as default };
